export default {"src":"https://cloudflare.edhrec.com/_next/static/media/mana12.77eec332.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};